import { Component, OnInit, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ServiceVariantModel } from 'src/models/ServiceVariantModel';
import { FilterAbstractModel } from 'src/models/FilterAbstractModel';

@Component({
  selector: 'app-service-variant-filter',
  templateUrl: './service-variant-filter.component.html',
  styleUrls: ['./service-variant-filter.component.scss']
})
export class ServiceVariantFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {


  listServiceVariantFilter: any[];
  optionSelected: any;

  @Input() serviceVariantData: any;
  @Input() serviceVariantSelected: ServiceVariantModel;

  constructor() {
    super();
   }

   ngOnInit() {
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('serviceVariantData' in changes) {
      this.listServiceVariantFilter = this.serviceVariantData;
      this.optionSelected = null;
    }
    if (this.serviceVariantSelected) {
      this.optionSelected = this.serviceVariantSelected;
    }
  }

  ngOnDestroy(): void {
  }

}
